import { memo, SVGAttributes } from 'react';

interface Props extends Omit<SVGAttributes<SVGElement>, 'fill'> {
  fill?: boolean;
}
export const StarIcon = memo(({ fill, ...rest }: Props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M12 2L15 8L21 9L16.5 13.5L18 20L12 17L6 20L7.5 13.5L3 9L9 8L12 2Z" fill="currentColor" fillOpacity={fill ? 1 : 0} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C12.2841 1.25 12.5438 1.4105 12.6708 1.66459L15.5 7.32299L21.1233 8.2602C21.4004 8.30639 21.6285 8.50358 21.7142 8.77112C21.8 9.03866 21.729 9.33168 21.5303 9.53033L17.3243 13.7364L18.7308 19.8314C18.7961 20.1143 18.6922 20.4096 18.464 20.5893C18.2358 20.7689 17.9244 20.8007 17.6646 20.6708L12 17.8385L6.33541 20.6708C6.07564 20.8007 5.76423 20.7689 5.53604 20.5893C5.30785 20.4096 5.2039 20.1143 5.26921 19.8314L6.67574 13.7364L2.46967 9.53033C2.27102 9.33168 2.20004 9.03866 2.28578 8.77112C2.37152 8.50358 2.59958 8.30639 2.8767 8.2602L8.49998 7.32299L11.3292 1.66459C11.4562 1.4105 11.7159 1.25 12 1.25ZM12 3.67705L9.67082 8.33541C9.56351 8.55003 9.35999 8.70035 9.1233 8.7398L4.56086 9.5002L8.03033 12.9697C8.21318 13.1525 8.28894 13.4167 8.23079 13.6686L7.08885 18.617L11.6646 16.3292C11.8757 16.2236 12.1243 16.2236 12.3354 16.3292L16.9111 18.617L15.7692 13.6686C15.7111 13.4167 15.7868 13.1525 15.9697 12.9697L19.4391 9.5002L14.8767 8.7398C14.64 8.70035 14.4365 8.55003 14.3292 8.33541L12 3.67705Z"
      fill="currentColor"
    />
  </svg>
));

export default StarIcon;
